import About from "./Components/About";
import Contact from "./Components/Contact";
import Navbar from "./Components/Navbar";
import Projects from "./Components/Projects";
import TechStack from "./Components/TechStack";

function App() {
  return (
    <>
      <Navbar />
      <About />
      <TechStack />
      <Projects />
      <Contact />
    </>
  );
}

export default App;
